// extracted by mini-css-extract-plugin
export default {"card":"ContentCard_card__kP1zH","materialicon":"ContentCard_materialicon__0INgs","content":"ContentCard_content__GJeWR"};